import { CallApi } from './configApi';

import {
  Options, RoomList, SaveBookingData,
  UpdateBookingData, DataCalendar, DataRebook,
  DownLoadInstruction, DataHomeScreen
} from './mode';

function* getRoomListAPI() {
  const body = RoomList();
  return yield CallApi(body)
}

function* getOptionsAPI() {
  const body = Options();
  return yield CallApi(body)
}

function* saveBookingData(bookingData) {
  const body = SaveBookingData(bookingData);
  return yield CallApi(body)
}

function* updateBookingData(updateData) {
  const body = UpdateBookingData(updateData);
  return yield CallApi(body)
}

function* getDataCalendar() {
  const body = DataCalendar();
  return yield CallApi(body)
}

function* getDataReBook() {
  const body = DataRebook();
  return yield CallApi(body)
}

function* getDataFileDownload(payload) {
  const body = DownLoadInstruction(payload);
  const res = yield CallApi(body);
  return res
}

function* getDataHomeScreen(payload) {
  const body = DataHomeScreen(payload);
  return yield CallApi(body)
}

export {
  getRoomListAPI, getOptionsAPI,
  saveBookingData, updateBookingData, getDataCalendar, getDataReBook,
  getDataFileDownload, getDataHomeScreen
}
